export default {
  title: "Berechnungsvorlagen",
  filter: {
    name: "Vorlagenname",
    namePlaceholder: "Bitte Vorlagennamen eingeben",
    type: "Vorlagentyp",
    typePlaceholder: "Bitte Vorlagentyp auswählen",
  },
  table: {
    name: "Vorlagenname",
    type: "Typ",
    createdAt: "Erstellt am",
    actions: "Aktionen",
    single: "Einzelberechnung",
    batch: "Batch-Berechnung",
  },
  action: {
    edit: "Namen bearbeiten",
    use: "Verwenden",
  },
  modal: {
    editTitle: "Vorlagennamen bearbeiten",
    nameLabel: "Vorlagenname",
    namePlaceholder: "Bitte Vorlagennamen eingeben",
    nameRequired: "Bitte Vorlagennamen eingeben",
  },
  deleteConfirm: {
    title: "Vorlage löschen",
    content: "Sind Sie sicher, dass Sie diese Vorlage löschen möchten?",
  },
  message: {
    fetchFailed: "Vorlagenliste konnte nicht abgerufen werden",
    updateSuccess: "Vorlagenname erfolgreich aktualisiert",
    updateFailed: "Aktualisierung fehlgeschlagen",
    deleteSuccess: "Vorlage erfolgreich gelöscht",
  },
};
